import { render } from "./EscriptoriumBrowser.vue?vue&type=template&id=fd18016e&scoped=true"
import script from "./EscriptoriumBrowser.vue?vue&type=script&lang=js"
export * from "./EscriptoriumBrowser.vue?vue&type=script&lang=js"

import "./EscriptoriumBrowser.vue?vue&type=style&index=0&id=fd18016e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd18016e"]])

export default __exports__